module.exports = __webpack_public_path__ + "static/media/cookie3-angle.f4c738e5.png";